import { PaymentItemType, PaymentItemInitialEnteredAmount } from './enums';

export class PaymentItemTableConfiguration {
	itemType: PaymentItemType = PaymentItemType.NotSet;
	initialAmountType: PaymentItemInitialEnteredAmount = PaymentItemInitialEnteredAmount.accountBalance;
	enableItemSelection: boolean = true;
	selectFirstItemUponLoad: boolean = false;
	isPaymentAmountEditable: boolean = false;
	isPayInFull: boolean;
	isPayOffEarly: boolean;
	useMultiselect: boolean = false;
	showSubtotal: boolean = false;
	showShortPayReason: object = {};

	// properties for hiding/showing columns
	onlyShowSelected: boolean = false;
	showDueDate: boolean = true;
	showStatementLink: boolean = true;
	showPaymentAmount: boolean = false;
	showInitialAmount: boolean = true;
	showBucket: boolean = false;

	// custom label text
	paymentAmountLabel: string;

	isGuarantorBillingEnabled: boolean;

}
